<template>
  <div>
    <div class="Publisher">
      <div class="title">发布者</div>
      <div @click="goBkOrBj" class="logo">
        <a href="" style="display: block">
          <img
            v-if="autherInfo.headImg"
            v-lazy="`${$global.imgUrl}${autherInfo.headImg}`"
            alt=""
          />
          <img v-else src="@/assets/img/details/qikan.png" alt="" />
          <span>{{ autherInfo.name }}</span>
        </a>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div class="time">{{ autherInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ timeData.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ timeData.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div v-if="detailsData.data" class="Publisher">
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <img
          v-if="periodicalInfo.headImg"
          v-lazy="`${$global.imgUrl}${periodicalInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div v-if="periodicalInfo.foundedDate" class="time">
            {{ periodicalInfo.foundedDate }}
          </div>
          <div class="time" v-else>--</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div class="author">
      <div class="title">作者</div>
      <div class="user" v-if="autherList">
        <div v-for="(item, i) in autherList" :key="i" class="userImg">
          <template v-if="i >= index * 3 && i < index + 3">
            <img
              @click="goto(item)"
              class="img"
              v-lazy="`${$global.imgUrl}${item.headImg}`"
              alt=""
            />
            <div @click="goto(item)" class="name">{{ item.realName }}</div>
            <div class="shunxu">
              {{
                i === 0
                  ? "第一作者"
                  : i === autherList.length - 1
                  ? "通讯作者"
                  : "其他作者"
              }}
            </div>
          </template>
        </div>
      </div>
      <div class="dian">
        <!--        {{allPage}}-->
        <div v-for="(item, i) in allPage" :key="i">
          <span @click="setIndex(i)" :class="i == index ? 'act' : ''"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "right",
  props: [
    "type",
    "detailsData",
    "autherInfo",
    "autherList",
    "periodicalInfo",
    "periodiID",
  ],
  watch: {
    detailsData() {
      this.getPublisherInfo();
    },
  },
  computed: {
    allPage() {
      if (this.autherList.length) {
        return Math.ceil(this.autherList.length / 3);
      } else {
        return 0;
      }
    },
    ...mapState(["hasLogin"]),
  },
  methods: {
    goBkOrBj() {
      if (this.detailsData.data.userType === 2) {
        let routeUrl = this.$router.resolve({
          path: `/jghdetail`,
          query: {
            title: "机构号",
            id: this.detailsData.data.companyId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/${
            this.detailsData.data.userType === 1 ? "bkzxdetail" : "bjzxdetail"
          }`,
          query: {
            title:
              this.detailsData.data.userType === 1 ? "百科在线" : "百家在线",
            id:
              this.detailsData.data.userType === 1
                ? this.detailsData.data.companyId
                : this.detailsData.data.createUser,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    goto(item) {
      console.log(item);
      this.$router.push(`/bjzxdetail?title=百家在线&id=${item.userId}`);
    },
    goBk() {
      console.log(this.periodicalInfo.id);
      this.$router.push(
        `/bkzxdetail?title=百科在线&id=${this.periodicalInfo.id}`
      );
    },
    setIndex(num) {
      this.index = num;
      console.log(this.index);
    },
    async getPublisherInfo() {
      let PublisherObj = {
        companyId: this.detailsData.data.companyId
          ? this.detailsData.data.companyId
          : null,
        createUser: this.detailsData.data.createUser,
      };
      console.log(PublisherObj, "PublisherObj");
      const timeData = await this.$apis.recomendServe.PublisherInfo(
        PublisherObj
      );
      this.timeData = timeData.data;
    },
  },
  data() {
    return {
      index: 0,
      aerList: [],
      timeData: {
        informationCount: 0,
        thesisCount: 0,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.Publisher {
  width: 270px;
  height: 250px;
  padding-left: 25px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      // height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      white-space: nowrap; //不换行
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //变成...
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;
      margin-top: -5px;
      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}

.author {
  width: 270px;
  padding-left: 25px;
  padding-bottom: 25px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    //font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
    font-size: 14px;
  }

  .user {
    width: 220px;
    //background: pink;
    display: flex;
    //margin-left: 10px;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }

  .dian {
    width: 220px;
    //background: pink;
    display: flex;
    justify-content: center;

    span {
      display: block;
      width: 8px;
      margin-left: 3px;
      margin-right: 3px;
      margin-top: 27px;
      height: 5px;
      background: #cccccc;
      border-radius: 2px;
    }

    .act {
      background: #007fff;
    }
  }

  .userImg {
    //float: left;
    //background: pink;
    //margin: 0 auto;
    //margin-left: 5px;
    //margin-right: 5px;
    //display: flex;
    .img {
      //background: pink;
      border-radius: 50%;
      width: 60px;
      height: 60px;
    }

    .name {
      width: 70px;
      text-align: center;
      font-size: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #263d78;
    }

    .shunxu {
      width: 70px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }
  }
}
</style>
